import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from 'contexts/authentication';
import { AppRoute } from 'share/types/routes';

/**
 * HOC to wrap components for the authorized contents
 */
export default function WithAuth<T extends {}>(
  Component: React.ComponentType<T>
) {
  const Wrapper = (props: T) => {
    const auth = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
      if (!auth.token) {
        navigate(AppRoute.Login, { replace: true });
      }
    }, [auth, navigate]);

    if (!auth.token) {
      return null;
    }

    return <Component {...props} />;
  };

  return Wrapper;
}
